namespace advisorop.components.advisor {

    export class AdvisorCashMonitorController {
        cashMonitorDetails: Array<any>;
        advisoryFirmId: number;
        pageLen: number;
        issuesCount: number;
        showNeto: boolean = true;
        dg: DevExpress.ui.dxDataGridOptions;
        advisoryFirms: domains.IAdvisoryFirm[];
        selFirm: domains.IAdvisoryFirm;
        mvDate: Date = null;

        upToFive: number = 0;
        fiveToTwentyFive: number = 0;
        twentyFiveToFifty: number = 0;
        fiftyToSeventyFive: number = 0;
        seventyFiveToOneHundred: number = 0;

        adminMode: domains.IAdminMode;
        adminModeEnabled: boolean = false;
        ad

        // grid instance
        dgCashMonitor: DevExpress.ui.dxDataGrid;

        isInitializing: boolean = false;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#advisorCashMonitorContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }

        static $inject = ["advisorService", "generalService", "advisorDashboardService", "$rootScope"]; //, "advisoryFirmApi"];
        constructor(
            private advisorService: services.AdvisorService,
            private generalService: services.GeneralService,
            private ads: services.AdvisorDashboardService,
            private $rootScope: ng.IRootScopeService
            //private advisoryFirmApi: services.AdvisoryFirmApi
            ) {


            this.dg = {
                export: {
                    enabled: true,
                    fileName: "CashMonitor"
                },
                bindingOptions: {
                    dataSource: "vm.cashMonitorDetails",
                },
                //height: 400,
                scrolling: {
                    mode: "standard",
                    scrollByContent: true,
                    preloadEnabled: false,
                    useNative: false
                },
                paging: {
                    pageSize: this.pageLen,
                    enabled: true
                },
                rowAlternationEnabled: true,
                //width: 1000,
                showBorders: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                selection: {
                    allowSelectAll: false,
                    mode: "single"
                },
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: ""
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                onInitialized: function (e: any) {
                    //console.log('Initialising...');
                    this.dgCashMonitor = e.component;
                },
                wordWrapEnabled: true,

                columns: [
                    { dataField: "accountId", caption: "", cellTemplate: "colActions", width: 30 },
                    { dataField: "accountNumber", caption: "Account Number", width: 120 },
                    { dataField: "accountName", caption: "Account Name", width: 400 },
                    { dataField: "advisorNames", caption: "Advisor", width: 120, visible: false },
                    { dataField: "accountValue", caption: "Account Value", format: "currency", width: 80 },
                    { dataField: "cashBalance", caption: "Cash Balance", format: "currency", width: 80 },
                    { dataField: "cashPercentage", caption: "Cash %", format: { type: "percent", precision: 2 }, width: 80, sortIndex: 0, sortOrder: "desc" },
                ],
                masterDetail: {
                    enabled: true,
                    template: "sleeves",
                    autoExpandAll: false
                },
                onCellPrepared: this.oncp,
                onContentReady: (e) => {
                    e.component.columnOption("advisorNames", "visible", this.adminModeEnabled);
                }

            };

            this.$rootScope.$on('adminModeChanged', (event: ng.IAngularEvent) => {
                this.loadCashMonitor();
            }); 

        }

        /**
         * report: AssetAllocation, Holdings, Performance, Transactions
         * level: will always be A-account or S-sleeve account
         * */
        openReport = (report: string, level: string, account: any) => {
            this.ads.calculateBackOfficeParamsAsync(level, account.accountId).then(params => {
                this.ads.openBackOfficeReport(report, params);
            });
        }

        oncp = function (e: any) {
            if (e.rowType === 'data' && e.column.command === 'expand') {
                if (!(e.row.data && e.row.data.sleeves && e.row.data.sleeves.length > 0)) {
                    e.cellElement.removeClass('dx-datagrid-expand');
                    e.cellElement.empty();
                }
            }
        }

        loadCashMonitor() {

            this.mvDate = null;

            let rez: any;

            this.isInitializing = true;

            this.upToFive = 0;
            this.fiveToTwentyFive = 0;
            this.twentyFiveToFifty = 0;
            this.fiftyToSeventyFive = 0;
            this.seventyFiveToOneHundred = 0;
            this.issuesCount = 0;


            this.adminMode = this.advisorService.getAdminMode();
            this.adminModeEnabled = this.adminMode && this.adminMode.enabled;

            //console.log("ADMinMode:", adminMode);
            //console.log("ADMinModeEnabled:", adminModeEnabled);

            //if (this.advisoryFirmId && this.advisoryFirmId > 0) {
            //console.log("Loading cash monitor data for firm: " + this.advisoryFirmId);
            this.cashMonitorDetails = [];
            rez = this.advisorService.getCashMonitorData(this.adminModeEnabled, this.adminModeEnabled ? this.adminMode.advisoryFirm.id : null);
            //}

            rez.then(response => {
                this.cashMonitorDetails = response.data;
                //console.log("CashMonitorDetails:",this.cashMonitorDetails);
                if (this.cashMonitorDetails.length > 0) {
                    // The Market Value Date on all account rows is the same (date from the BO table), so we can take the date from the first row.
                    //this.mvDate = this.cashMonitorDetails[0].details.marketValueDate;
                    this.upToFive = response.data.filter(w => w.cashPercentage < .05).length;
                    this.fiveToTwentyFive = response.data.filter(w => w.cashPercentage > .05 && w.cashPercentage < .25).length;
                    this.twentyFiveToFifty = response.data.filter(w => w.cashPercentage > .25 && w.cashPercentage < .50).length;
                    this.fiftyToSeventyFive = response.data.filter(w => w.cashPercentage > .50 && w.cashPercentage < .75).length;
                    this.seventyFiveToOneHundred = response.data.filter(w => w.cashPercentage > .75).length;
                    this.issuesCount = this.cashMonitorDetails.length;
                }
                this.isInitializing = false;
            }, err => {
                    this.generalService.showError(err);
                    this.isInitializing = false
            })
            .catch(err => {
                this.generalService.showError(err);
            });
        };

        // We can make this functionality work if we implement a listen on the advisory firm
        // selection available to advisor admin mode users... for now we will just load in onInit.
        //firmChanged(): void {
        //    this.advisoryFirmId = this.selFirm.id;
        //    this.loadCashMonitor();
        //}

        $onInit(): void {
            this.loadCashMonitor();

            //this.advisoryFirmApi.getAdvisoryFirmsLight().then(response => {
            //    this.advisoryFirms = response.data;
            //    this.selFirm = this.advisoryFirms[0];
            //    this.firmChanged();
            //}).catch(reason => {
            //});
        }

        $onChanges(evt) {
            for (var key in evt) {
                //if (key === "advisoryFirmId" && this.advisoryFirmId) {
                //    console.log("Cash Monitor details data: ");
                //    console.log(this.cashMonitorDetails);
                //}
            }
        };
    }


    class AdvisorCashMonitor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                //advisoryFirmId: "<",
                pageLen: "<",
                issuesCount: "="
            };
            this.controller = AdvisorCashMonitorController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/advisor-cash-monitor.html";
        }
    }
    angular.module(Constants.APP).component("advisorCashMonitor", new AdvisorCashMonitor());

}